import React, { useContext } from 'react'
import styled from 'styled-components'
import CreationToolSupercutField from '../../../../../../types/super-cut-field'
import WatermarkPositionSlider from '../../../../../form-fields/super-cut/watermark-position-slider'
import { CreationCaptureInfoContext } from '../manager'

const WatermarkPosition = styled(WatermarkPositionSlider)`
    grid-column: span 2;
`

type Props = {
    field: CreationToolSupercutField
}

const CreationCaptureInfoWatermarkPosition = ({ field }: Props) => {
    const { watermarkPosition } = useContext(CreationCaptureInfoContext)

    return (
        <WatermarkPosition
            {...{
                field,
                defaultPosition: watermarkPosition,
            }}
        />
    )
}

export default CreationCaptureInfoWatermarkPosition
